export default "__VITE_ASSET__c6f704f2__"